import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";

import { NOTIFY, DEFAULTS } from "common/config";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
const ApiReportsHandler = new ApiReports();

// const $ = jQuery;

const DocumentRenewal = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [exportName, setExportName] = useState("");
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "vehicleNumber",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "15%",
    },
    {
      key: "permitValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PERMIT_UPTO,
      width: "10%",
    },
    {
      key: "fcValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FITNESS_UPTO,
      width: "10%",
    },
    {
      key: "insuranceValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INSURENCE_UPTO,
      width: "12%",
    },
    {
      key: "emissionValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EMMISSION_VALIDITY,
      width: "13%",
    },
    {
      key: "registrationValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.REGISTRATION_VALIDITY,
      width: "15%",
    },

    {
      key: "roadTaxEndDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROADTAX_UPTO,
      width: "10%",
    },
    {
      key: "speedLimiterEndDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SPEED_LIMIT_UPTO,
      width: "15%",
    },
  ];
  // const generateReportGrid = (res: any) => {
  //   let title = LABELS.USER_LOG_REPORT;
  //   if (projectRef.current) {
  //     title += " - " + projectRef.current.selectedValue.label;
  //   }
  //   $("#reportGrid").DataTable({
  //     dom: "Bfrtip",
  //     buttons: [
  //       {
  //         extend: "csv",
  //         className: "reportBtn",
  //         title: title,
  //         text: "<i class='fa fa-download'></i>",
  //       },
  //     ],
  //     paging: true,
  //     pageLength: 15,
  //     columns: res.cols,
  //     data: res.rows,
  //     order: [],
  //   });
  // };

  const loadChart = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    setExportName(
      LABELS.FROM_DATE + ": " + fromDt + "\n" + LABELS.TO_DATE + ": " + toDt
    );
    const args = {
      fromDt,
      toDt,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    setChartData(null);
    setRows(null);
    ApiReportsHandler.getDocRenewal(args).then((res) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
        }
        console.log("response.rows:", response.rows);
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  const projectRef: any = useRef();

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.DOCUMENT_RENEWAL_REPORT}</li>
        </ul>
        <h4>{TITLES.DOCUMENT_RENEWAL_REPORT}</h4>
        <p className="SubTitles">{SUB_TITLES.DOCUMENT_RENEWAL_REPORT}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div id="chartForm">
            <div
              className="formGroup"
              style={{
                display: "flex",
                marginTop: 5,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>

              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  // loading={!chartData}
                />
              </div>
            </div>
          </div>

          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={"documentRenewalReport"}
              title={LABELS.DOCUMENT_RENEWAL_REPORT}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={exportName}
              //onReload={reloadGrid}
              // onAdd={onAdd}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DocumentRenewal);
